var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClavier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333e49;opacity:0.7;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PAV\\xC9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 455.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 369.74,
    cy: 381.05,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 500,
    cy: 381.05,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 630.26,
    cy: 381.05,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 369.74,
    cy: 500,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 500,
    cy: 500,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 630.26,
    cy: 500,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 369.74,
    cy: 618.95,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 500,
    cy: 618.95,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 630.26,
    cy: 618.95,
    r: 51.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClavier);
export default __webpack_public_path__ + "static/media/clavier.91c476450789f7b2fb9950b01d14c88d.svg";
export { ForwardRef as ReactComponent };